import { render } from "./IntegrationIndexPage.vue?vue&type=template&id=386c63c1"
import script from "./IntegrationIndexPage.vue?vue&type=script&lang=js"
export * from "./IntegrationIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__